import useSeo from "@/hooks/useSeo";
import { faqs } from "@/mocks/faqs";
import Hero from "@/pages/home/components/Hero";
import HotTicker from "@/pages/home/components/HotTicker";
import HotTopics from "@/pages/home/components/HotTopics";
import CategoryGrid from "@/pages/home/components/CategoryGrid";
import MemePreview from "@/pages/home/components/MemePreview";
import CreativeWall from "@/pages/home/components/CreativeWall";
import Testimonials from "@/pages/home/components/Testimonials";
import FaqPreview from "@/pages/home/components/FaqPreview";
import CtaBanner from "@/pages/home/components/CtaBanner";

const homeJsonLd = [
  {
    "@context": "https://schema.org",
    "@type": "WebSite",
    name: "513吃瓜",
    alternateName: "513吃瓜热梗社区",
    url: "https://law818.cn/",
    inLanguage: "zh-CN",
    description:
      "513吃瓜是面向年轻网民的热梗聚合社区，整理网络热梗的来龙去脉、衍生表情包、二创二改与评论区神评。",
  },
  {
    "@context": "https://schema.org",
    "@type": "Organization",
    name: "513吃瓜",
    url: "https://law818.cn/",
    email: "hello@513chigua.com",
    description: "网络热梗、表情包与二创二改内容聚合社区。",
  },
  {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: faqs.slice(0, 5).map((item) => ({
      "@type": "Question",
      name: item.q,
      acceptedAnswer: { "@type": "Answer", text: item.a },
    })),
  },
];

export default function Home() {
  useSeo({
    title: "513吃瓜 | 后续梗 表情包 二创二改，网络热梗评论区灵感合集",
    description:
      "513吃瓜是热梗衍生内容集中地，整理后续进展、表情包出处、二创二改作品与评论区神评，网络热梗一网打尽，玩梗冲浪就看这里。",
    keywords: "513吃瓜,513吃瓜后续梗,513吃瓜表情包,513吃瓜二创二改,513吃瓜网络热梗",
    path: "/",
    jsonLd: homeJsonLd,
  });

  return (
    <>
      <Hero />
      <HotTicker />
      <HotTopics />
      <CategoryGrid />
      <MemePreview />
      <CreativeWall />
      <Testimonials />
      <FaqPreview />
      <CtaBanner />
    </>
  );
}